module.exports = __webpack_public_path__ + "img/logo-lc.f949c70b.png";